<template>
  <div class="container mall mall-search" ref="searchList">
    <div class="search">
      <div class="mall-header">
        <form action="">
          <van-search
            v-model="keyword"
            ref="searchInput"
            autofocus
            placeholder="请输入关键词进行搜索"
            @search="onSearch"
          />
        </form>
      </div>
      <div class="search-body">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          ref="goodsList"
          :finished-text="productData.length > 0 ? '已全部加载完成' : ''"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <div
            v-for="product in productData"
            :key="product.id"
            class="goods-list"
            @click="$router.push({path: '/mall/view', query: {id: product.id}})"
          >
            <div class="goods-img" :style="{backgroundImage: 'url(' + product.logo + ')'}">
              <van-tag type="primary" v-if="product.isrecommend"><i class="iconfont iconshujituijian"></i>推荐</van-tag>
            </div>
            <div class="goods-info">
              <div class="goods-title van-multi-ellipsis--l2">{{product.productname}}</div>
              <div class="goods-price">¥{{product.price}}</div>
            </div>
          </div>
        </van-list>
        <div class="noData" v-if="finished && productData.length === 0">
          <img src="../../assets/images/noData.png" alt="">
          <p>抱歉，暂无相关商品</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  const pageload = 10
  export default {
    name: 'mallIndex',
    data () {
      return {
        loading: false,
        finished: false,
        error: false,
        index: 1,
        keyword: '',
        searchkeywords: '',
        productData: [],
        scrollT: 0
      }
    },
    activated () {
      this.$nextTick(function () {
        this.$refs.searchList.scrollTop = this.scrollT
        // this.$refs.searchInput.focus()
        this.$refs.searchInput.getElementsByTagName('input')[0].focus()
      })
    },
    created () {
      this.$toast.allowMultiple()
    },
    methods: {
      onSearch () {
        this.searchkeywords = this.keyword
        this.productData = []
        this.index = 1
        this.$nextTick(function () {
          this.finished = false
          this.$refs.goodsList.check()
        })
      },
      onLoad () {
        this.$fetch.get(API.PRODUCTLIST, {
          producttypeid: '',
          subtypeid: '',
          searchkeywords: this.searchkeywords,
          pageNum: this.index,
          pageSize: pageload
        }).then(response => {
          // console.log(response)
          if (response.status !== 200) {
            var msg = response.message? response.message : '商品获取失败，请刷新！'
            this.$toast.fail(msg)
            this.loading = false
            this.finished = true
            this.error = true
            return
          }
          if (response.data.productList.length > 0) {
            this.productData = this.productData.concat(response.data.productList)
            this.index += 1
            this.loading = false
            if (response.data.productList.length < pageload) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
          }
        }).catch(error => {
          console.log(error)
          this.loading = false
          this.finished = true
          this.error = true
        })
      }
    },
    beforeRouteLeave (to, from, next) {
      if (to.name === 'mallIndex') {
        this.loading = false
        this.finished = false
        this.error = false
        this.index = 1
        this.keyword = ''
        this.searchkeywords = ''
        this.productData = []
        this.scrollT = 0
      } else {
        this.scrollT = this.$refs.searchList.scrollTop
      }
      next()
    }
  }
</script>

<style lang="stylus">
  
</style>